/**
 * 企画連絡承認画面　企画連絡承認商品取得VOクラス
 */
export class ApprovalItemListModel {

    public orderCode: string = null;                                              // 受注コード
    public pCode: string = null;                                                  // Ｐコード

}
